export default {
    data: `{  
   "title":"AudioEditor111111",
   "slides":[  
      {  
         "content":[  
            {  
               "type":"Background",
               "hotSpot":"",
               "logicalName":"",
               "frameLabel":"",
               "xlinkHref":"",
               "moods":[  

               ],
               "stroke":"#000000",
               "strokeWidth":1,
               "strokeOpacity":0,
               "fill":"#ffffff",
               "fillOpacity":1,
               "uuid":"9b2b6148-a865-4268-bfe9-753e99b7957d"
            }
         ],
         "initialized":true,
         "time":4,
         "uuid":"b198b860-6e54-4e5e-b2d4-8ebe2600a617",
         "contentItemId":-1,
         "sound":"",
         "soundEffect":"",
         "soundVolume":0.5,
         "soundEffectVolume":0.5
      }
   ],
   "audioEditor":{  
      "timelines":[  
         {  
            "index":0,
            "volume":1,
            "audios":[  
               {  
                  "uuid":"1ff05e77-b6f6-42b7-bcdd-955c14e2a329",
                  "title":"Bell",
                  "href":"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/1837856.mp3",
                  "inPoint":0,
                  "outPoint":0,
                  "left":6.761904761904762,
                  "duration":8,
                  "showControlPoint":false
               }
            ],
            "isSelected":false
         },
         {  
            "index":1,
            "volume":1,
            "audios":[  
               {  
                  "title":"Car chase",
                  "href":"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/16201446.mp3",
                  "uuid":"4bcabf7e-4e43-40b6-a8f8-c90804c59664",
                  "left":0,
                  "outPoint":38.22857142857143,
                  "duration":17.771428571428572,
                  "showControlPoint":false
               }
            ],
            "isSelected":false
         },
         {  
            "index":2,
            "volume":1,
            "audios":[  
               {  
                  "uuid":"f0cf9c67-c929-4335-a966-bcf94e050da8",
                  "title":"Closing door",
                  "href":"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/3840295.mp3",
                  "inPoint":0,
                  "outPoint":0,
                  "left":4.3619047619047615,
                  "duration":4,
                  "showControlPoint":false
               }
            ],
            "isSelected":false
         },
         {  
            "index":3,
            "volume":1,
            "audios":[  
               {  
                  "uuid":"7ea33717-521d-4e1f-b1b8-f8ef968820bd",
                  "title":"Fog horn",
                  "href":"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/3840397.mp3",
                  "inPoint":0,
                  "outPoint":5.885714285714286,
                  "left":3.1809523809523808,
                  "duration":13.114285714285714,
                  "showControlPoint":false
               }
            ],
            "isSelected":false
         },
         {  
            "index":4,
            "volume":1,
            "audios":[  
               {  
                  "uuid":"81bf198a-c4f9-47ac-9523-4dfce4b5bf30",
                  "title":"Siren",
                  "href":"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/1837890.mp3",
                  "inPoint":0,
                  "outPoint":12.342857142857143,
                  "left":1.6571428571428573,
                  "duration":15.657142857142857,
                  "showControlPoint":true
               }
            ],
            "isSelected":false
         },
         {  
            "index":5,
            "volume":1,
            "audios":[  

            ],
            "isSelected":false
         }
      ],
      "markerPosition":17.314285714285713,
      "timelineWidth":1372,
      "refreshAudioTrack":0.014986289186555313,
      "trackMenu":-1,
      "zoomValue":4
   }
}`
};



/** WEBPACK FOOTER **
 ** ./docs/audioProduction.js
 **/